import { render, staticRenderFns } from "./ToolbarBtn.vue?vue&type=template&id=bf70862c&scoped=true&"
import script from "./ToolbarBtn.vue?vue&type=script&lang=js&"
export * from "./ToolbarBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf70862c",
  null
  
)

export default component.exports